document.addEventListener("turbolinks:load", function() {
  $('[data-toggle="time_picker"]').flatpickr({
    noCalendar: true,
    enableTime: true,
    dateFormat: 'H:i'
  });

  $('[data-toggle="date_picker"]').flatpickr({
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d"
  });
})
